import { createSlice } from '@reduxjs/toolkit';

const analyticsSlice = createSlice({
    name: 'analytics',
    initialState: {
        userAnalytics: { data: null, loading: false, error: null },
        assessmentsAnalytics: { data: null, loading: false, error: null },
        participationStats: { data: null, loading: false, error: null },
        systemInsights: { data: null, loading: false, error: null },
    },
    reducers: {
        // Start actions
        fetchUserAnalyticsStart: (state) => {
            state.userAnalytics.loading = true;
            state.userAnalytics.error = null;
        },
        fetchAssessmentsAnalyticsStart: (state) => {
            state.assessmentsAnalytics.loading = true;
            state.assessmentsAnalytics.error = null;
        },
        fetchParticipationStatsStart: (state) => {
            state.participationStats.loading = true;
            state.participationStats.error = null;
        },
        fetchSystemInsightsStart: (state) => {
            state.systemInsights.loading = true;
            state.systemInsights.error = null;
        },

        // Success actions
        fetchUserAnalyticsSuccess: (state, action) => {
            state.userAnalytics.loading = false;
            state.userAnalytics.data = action.payload;
        },
        fetchAssessmentsAnalyticsSuccess: (state, action) => {
            state.assessmentsAnalytics.loading = false;
            state.assessmentsAnalytics.data = action.payload;
        },
        fetchParticipationStatsSuccess: (state, action) => {
            state.participationStats.loading = false;
            state.participationStats.data = action.payload;
        },
        fetchSystemInsightsSuccess: (state, action) => {
            state.systemInsights.loading = false;
            state.systemInsights.data = action.payload;
        },

        // Fail actions
        fetchUserAnalyticsFail: (state, action) => {
            state.userAnalytics.loading = false;
            state.userAnalytics.error = action.payload;
        },
        fetchAssessmentsAnalyticsFail: (state, action) => {
            state.assessmentsAnalytics.loading = false;
            state.assessmentsAnalytics.error = action.payload;
        },
        fetchParticipationStatsFail: (state, action) => {
            state.participationStats.loading = false;
            state.participationStats.error = action.payload;
        },
        fetchSystemInsightsFail: (state, action) => {
            state.systemInsights.loading = false;
            state.systemInsights.error = action.payload;
        },
    },
});

export const {
    fetchUserAnalyticsStart,
    fetchUserAnalyticsSuccess,
    fetchUserAnalyticsFail,
    fetchAssessmentsAnalyticsStart,
    fetchAssessmentsAnalyticsSuccess,
    fetchAssessmentsAnalyticsFail,
    fetchParticipationStatsStart,
    fetchParticipationStatsSuccess,
    fetchParticipationStatsFail,
    fetchSystemInsightsStart,
    fetchSystemInsightsSuccess,
    fetchSystemInsightsFail,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;